// Endpoint definitions for Courses API

export const COURSES = '/api/v1/courses';
export const COURSE = (courseId: string | number) => `/api/v1/courses/${courseId}`;
